import { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme"; // Adjust based on your theme configuration
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";

const Pgseedmap = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false); // State for Delete dialog
  const [selectedRow, setSelectedRow] = useState(null);
  const [newState, setNewState] = useState({ seasonId: "", createdBy: "" ,seedId: "", updatedBy: "",producerGroupId:""});
  const [updatedBy, setUpdatedBy] = useState(""); // State for updatedBy input

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("http://35.73.39.70:8081/api/producer-group-seed-mappings/get-all");
        console.log("API response:", response.data);
        setRows(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setOpenDelete(true); // Open Delete dialog
  };

  const handleDelete = async () => {
    if (!updatedBy) {
      alert("Please provide the updatedBy value.");
      return;
    }
  
    try {
      const { producerGroupSeedMappingId, updatedBy: rowUpdatedBy } = selectedRow; // Get the stateId and updatedBy of the selected row
  
      // Ensure row has an updatedBy value before proceeding
      if (!rowUpdatedBy) {
        alert("This row cannot be deleted as it doesn't have an updatedBy value.");
        return;
      }
  
      await axios.delete(`http://35.73.39.70:8081/api/producer-group-seed-mappings/delete/${producerGroupSeedMappingId}`, {
        headers: {
          'Content-Type': 'application/json'
        },
        data: { updatedBy: parseInt(updatedBy) }, // Ensure updatedBy is sent as a number
      });
  
      // Remove the deleted row from local state
      const updatedRows = rows.filter((row) => row.producerGroupSeedMappingId !== producerGroupSeedMappingId);
      setRows(updatedRows);
    } catch (error) {
      console.error("Error deleting data:", error);
    } finally {
      setOpenDelete(false);
      setUpdatedBy(""); // Reset updatedBy value
    }
  };
  
  const handleEdit = (row) => {
    setSelectedRow(row);
    setOpenEdit(true);
  };

  const handleView = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSelectedRow(null);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
    setNewState({ seasonId: "", createdBy: "" , seedId: "",producerGroupId:""});
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setUpdatedBy(""); // Reset updatedBy value
  };

  const handleSaveAdd = async () => {
    try {
      const response = await axios.post("http://35.73.39.70:8081/api/producer-group-seed-mappings/create", {
        seasonId: newState.seasonId,
        createdBy: newState.createdBy,
        seedId: newState.seedId,
        producerGroupId: newState.producerGroupId
      });
      console.log("Create response:", response.data);
      setRows((prevRows) => [...prevRows, response.data]);
    } catch (error) {
      console.error("Error creating state:", error);
    } finally {
      handleCloseAdd();
    }
  };

  const handleSaveEdit = async () => {
    try {
      const { producerGroupSeedMappingId, producerGroupId, updatedBy } = selectedRow;
      const response = await axios.put(`http://35.73.39.70:8081/api/producer-group-seed-mappings/update/${producerGroupSeedMappingId}`, {
        producerGroupId,
        updatedBy,
      });

      console.log("Update response:", response.data);
      
      const updatedRows = rows.map((row) => 
        row.producerGroupSeedMappingId === producerGroupSeedMappingId ? { ...row, producerGroupId, updatedBy } : row
      );
      setRows(updatedRows);
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      setOpenEdit(false);
    }
  };

  const columns = [
    { field: "seedId", headerName: "seed Id", flex: 1 },
    { field: "isActive", headerName: "Is Active", flex: 1, type: "boolean" },
    { field: "updatedBy", headerName: "Updated By", flex: 1 },
    { 
      field: "updatedAt", 
      headerName: "Updated At", 
      flex: 1, 
      type: "date", 
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleDateString(); // Formats to show only the date
      }
    },
    { field: "createdBy", headerName: "Created By", flex: 1 },
    { 
      field: "createdAt", 
      headerName: "Created At", 
      flex: 1, 
      type: "date", 
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleDateString(); // Formats to show only the date
      }
    },

    { field: "seasonId", headerName: "Season Id", flex: 1 },
    { field: "producerGroupId", headerName: "Producer Group Id", flex: 1 },
    { field: "producerGroupSeedMappingId", headerName: "producerGroupSeedMappingId ", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box>
            <IconButton onClick={() => handleView(params.row)}>
              <VisibilityIcon style={{ color: colors.greenAccent[500] }} />
            </IconButton>
            <IconButton onClick={() => handleEdit(params.row)}>
              <EditIcon style={{ color: colors.blueAccent[600] }} />
            </IconButton>
            <IconButton onClick={() => handleDeleteClick(params.row)}>
              <DeleteIcon style={{ color: colors.redAccent[600] }} />
            </IconButton>
          </Box>
        );
      },
    },
  ];
  

  return (
    <Box m="20px">
      <Header title="PG Seed Management" subtitle="List of PG Seed" />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Button
            variant="contained"
            color="primary"
            sx={{ marginTop: "20px" }}
            onClick={() => setOpenAdd(true)}
          >
            Add seed
          </Button>
        </Box>

        <DataGrid
          rows={rows}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          getRowId={(row) => row.stateId}
        />

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle> Pgseed Management</DialogTitle>
          <DialogContent>
            {selectedRow && (
              <>
                <Typography><strong>State ID:</strong> {selectedRow.stateId}</Typography>
                <Typography><strong>State Name:</strong> {selectedRow.stateName}</Typography>
                <Typography><strong>Is Active:</strong> {selectedRow.isActive ? "Yes" : "No"}</Typography>
                <Typography><strong>Updated At:</strong> {selectedRow.updatedAt}</Typography>
                <Typography><strong>Updated By:</strong> {selectedRow.updatedBy}</Typography>
                <Typography><strong>Created At:</strong> {selectedRow.createdAt}</Typography>
                <Typography><strong>Created By:</strong> {selectedRow.createdBy}</Typography>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openEdit} onClose={handleCloseEdit}>
          <DialogTitle>Edit seed</DialogTitle>
          <DialogContent>
            {selectedRow && (
              <>
                <TextField
                  autoFocus
                  margin="dense"
                  label="pgseed Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.producerGroupId}
                  onChange={(e) => setSelectedRow({ ...selectedRow, producerGroupId: e.target.value })}
                />
                <TextField
                  margin="dense"
                  label="Updated By"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={updatedBy}
                  onChange={(e) => setUpdatedBy(e.target.value)} // Handle updatedBy change
                />
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEdit}>Cancel</Button>
            <Button onClick={handleSaveEdit}>Save</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openAdd} onClose={handleCloseAdd}>
          <DialogTitle>Add seed</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="seasonId Name"
              type="text"
              fullWidth
              variant="outlined"
              value={newState.seasonId}
              onChange={(e) => setNewState({ ...newState, seasonId: e.target.value })}
            />
            <TextField
              margin="dense"
              label="Created By"
              type="text"
              fullWidth
              variant="outlined"
              value={newState.createdBy}
              onChange={(e) => setNewState({ ...newState, createdBy: e.target.value })}
            />
            <TextField
              margin="dense"
              label="seedId"
              type="text"
              fullWidth
              variant="outlined"
              value={newState.seedId}
              onChange={(e) => setNewState({ ...newState, seedId: e.target.value })}    
            />
            <TextField
              margin="dense"
              label="producerGroupId"
              type="text"
              fullWidth
              variant="outlined"
              value={newState.producerGroupId}
              onChange={(e) => setNewState({ ...newState, producerGroupId: e.target.value })}
            />  
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAdd}>Cancel</Button>
            <Button onClick={handleSaveAdd}>Add</Button>
          </DialogActions>
        </Dialog>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Updated By"
              type="text"
              fullWidth
              variant="outlined"
              value={updatedBy}
              onChange={(e) => setUpdatedBy(e.target.value)}
            />
            <Typography variant="body1" color="error" style={{ marginTop: '16px' }}>
              Are you sure you want to delete this state?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDelete}>Cancel</Button>
            <Button onClick={handleDelete} color="error">Delete</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Pgseedmap;
